import { useState, useCallback } from 'react';

export const useImpersonation = () => {
  const [impersonatedUser, setImpersonatedUser] = useState(null);

  const startImpersonation = useCallback((userId, displayName, email) => {
    setImpersonatedUser({
      id: userId,
      displayName: displayName || 'Unknown User',
      email: email || ''
    });
  }, []);

  const stopImpersonation = useCallback(() => {
    setImpersonatedUser(null);
  }, []);

  return {
    impersonatedUser,
    impersonatedUserId: impersonatedUser?.id || null,
    isImpersonating: impersonatedUser !== null,
    startImpersonation,
    stopImpersonation
  };
};
